<template>
  <el-dialog
    ref="addEditDialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="h720_dialog abow_dialog"
    width="1100px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-form
      ref="dialogAddEditForm"
      :model="dialogAddEditForm"
      :rules="dialogAddEditFormRules"
      class="add-edit-view-form"
      @submit.native.prevent
    >
      <div class="modal-box">
        <h3 class="modal-title">
          基础信息
        </h3>
        <div class="modal-row-box">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item
                label="工作任务分类"
                prop="type"
              >
                <el-radio-group v-model="dialogAddEditForm.type">
                  <el-radio :label="1">
                    客情维护
                  </el-radio>
                  <el-radio :label="2">
                    终端宣传
                  </el-radio>
                  <el-radio :label="3">
                    品牌推广
                  </el-radio>
                  <el-radio :label="4">
                    经营指导
                  </el-radio>
                  <el-radio :label="5">
                    终端调研
                  </el-radio>
                  <el-radio :label="6">
                    资料采集
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="默认任务"
                prop="isDefault"
              >
                <el-radio-group v-model="dialogAddEditForm.isDefault">
                  <el-radio :label="1">
                    是
                  </el-radio>
                  <el-radio :label="2">
                    否
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item
                label="工作任务名称"
                prop="name"
              >
                <el-input
                  v-model="dialogAddEditForm.name"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="任务要求"
                prop="actionRequire"
              >
                <el-radio-group
                  v-model="dialogAddEditForm.actionRequire"
                  @change="handleRequireChange"
                >
                  <el-radio :label="1">
                    照片
                  </el-radio>
                  <el-radio :label="2">
                    调研问题
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                label="省区"
                prop="provinceId"
              >
                <el-select
                  v-model="dialogAddEditForm.provinceId"
                  filterable
                  clearable
                  placeholder="请选择省区"
                  style="width:100%"
                  @change="handleProvinceChange"
                >
                  <el-option
                    v-for="item in provinceDataList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="城市"
                prop="cityId"
              >
                <el-select
                  v-model="dialogAddEditForm.cityId"
                  filterable
                  clearable
                  placeholder="请选择城市"
                  style="width:100%"
                  @change="handleCityChange"
                >
                  <el-option
                    v-for="item in cityDataList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="适用终端"
                prop="terminalTypeArray"
              >
                <el-checkbox-group v-model="dialogAddEditForm.terminalTypeArray">
                  <el-checkbox label="1">
                    重点终端
                  </el-checkbox>
                  <el-checkbox label="2">
                    潜力终端
                  </el-checkbox>
                  <el-checkbox label="3">
                    信息采集终端
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item
                label="工作任务规定详细说明"
                prop="description"
              >
                <el-input
                  v-model="dialogAddEditForm.description"
                  type="textarea"
                  :autosize="{minRows: 3}"
                  maxlength="512"
                  class="textarea-item"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col
              v-if="dialogAddEditForm.actionRequire === 1"
              :span="6"
            >
              <el-form-item
                label="照片数量"
                prop="imageNum"
              >
                <el-input-number
                  v-model="dialogAddEditForm.imageNum"
                  :min="0"
                  :max="9"
                  :controls="false"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="dialogAddEditForm.actionRequire === 2"
              :span="6"
            >
              <el-form-item label="问题数量">
                <el-input-number
                  v-model="mathQuestionNum"
                  disabled
                  :controls="false"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="dialogAddEditForm.actionRequire === 2"
              :span="6"
              class="button-col"
            >
              <el-button
                type="primary"
                plain
                round
                size="mini"
                icon="el-icon-plus"
                @click="handleAddQuestion"
              >
                添加走访调查问题
              </el-button>
            </el-col>
          </el-row>

          <el-row v-if="dialogAddEditForm.actionRequire === 2">
            <el-col :span="24">
              <el-table
                border
                size="mini"
                row-key="questionId"
                :data="actionQuestionDataList"
                class="draggable-table"
                style="width: 100%; margin:10px 0px;"
                :header-cell-style="{background:'#0076ff'}"
              >
                <el-table-column
                  label="序号"
                  prop="orderNum"
                  width="60"
                  align="center"
                />
                <el-table-column
                  label="问题内容(题干)"
                  prop="questionStem"
                  header-align="center"
                  show-overflow-tooltip
                />
                <el-table-column
                  label="问题类别"
                  prop="questionTypeValue"
                  align="center"
                  width="80"
                />
                <el-table-column
                  label="操作"
                  width="60"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      class="el-icon-delete"
                      style="color: red; font-size: 16px;"
                      @click="handleDeleteQuestion(scope.$index)"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="modal-box">
        <h3 class="modal-title">
          备注信息
        </h3>
        <div class="modal-row-box">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item prop="remark">
                <el-input
                  v-model="dialogAddEditForm.remark"
                  type="textarea"
                  placeholder="请输入备注说明"
                  maxlength="128"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="handleSave"
      >
        保存
      </el-button>
      <el-button @click="modalClose">
        关闭
      </el-button>
    </div>

    <!-- 搜索题库问题 -->
    <search-question-dialog
      :dialog-visible.sync="dialogChooseQuestionVisible"
      @chooseActionQuestion="handleChooseActionQuestion"
    />
  </el-dialog>
</template>

<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 表格拖拽排序
import Sortable from 'sortablejs';
// 题库问题搜索组件
import searchQuestionDialog from './searchQuestionDialog';
// 区域API
import { listAreaApi } from '@/api/v2/area'
// 终端走访配置动作API
import { saveTerminalVisitConfigActionApi, viewTerminalVisitConfigActionApi } from '@/api/v2/terminalVisitConfigAction'


export default {
  components: { searchQuestionDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        type: [{ required: true, message: '请选择工作任务分类', trigger: 'change' }],
        name: [
          { required: true, message: '请输入终端走访工作任务名称', trigger: 'blur' },
          { max: 64, message: '工作任务名称不能超过 64 字符', trigger: 'blur' }
        ],
        actionRequire: [{ required: true, message: '请选择工作任务要求', trigger: 'change' }],
        isDefault: [{ required: true, message: '请选择是否默认工作任务', trigger: 'change' }],
        terminalTypeArray: [{ required: true, type: 'array', message: '请选择工作任务适用终端类型', trigger: 'change' }],
        imageNum: [
          { required: true, message: '请输入工作任务要求的照片数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '工作任务要求的照片数量必须大于0', trigger: 'blur' }
        ],
        remark: [
          { max: 128, message: '备注说明不能超过 128 字符', trigger: 'blur' }
        ]
      },
      actionQuestionDataList: [],
      provinceDataList: [],
      cityDataList: [],
      sortTable: null,
      dialogChooseQuestionVisible: false,
    }
  },
  computed: {
    mathQuestionNum: {
      get() {
        return Number(this.actionQuestionDataList.length)
      },
      set(val) {
        return val
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this;
        _this.dialogAddEditForm = {
          type: 1,
          name: '',
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          terminalTypeArray: [],
          terminalType: '',
          actionRequire: 1,
          imageNum: 0,
          questionNum: 0,
          description: '',
          isDefault: 1,
          remark: '',
          // 配置动作中包含的问题明细JSON字符串
          actionQuestionData: ''
        }
        _this.actionQuestionDataList = []
        _this.provinceDataList = []
        _this.cityDataList = []
        _this.loadProvinceData();

        // 获取配置动作信息
        if (_this.eventType === 'edit') {
          _this.initConfigActionData()
        }

        _this.$nextTick(() => {
          _this.initDropSort();
          _this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    },
    actionQuestionDataList: {
      handler: function (newVal) {
        let index = 1;
        newVal.forEach((item) => {
          item.orderNum = index;
          index++;
        })
      },
      deep: true
    }
  },
  methods: {
    // 初始化Sortable
    initDropSort() {
      let _this = this;
      const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody');
      _this.sortTable = new Sortable(tbody, {
        draggable: ".el-table__row",
        delay: 0,
        onEnd: ({ newIndex, oldIndex }) => { // 监听拖动结束事件
          //如果位置一样return
          if (newIndex === oldIndex) {
            return;
          }
          const currRow = _this.actionQuestionDataList.splice(oldIndex, 1)[0]
          _this.actionQuestionDataList.splice(newIndex, 0, currRow)
        }
      })
    },
    // 初始化对象数据
    initConfigActionData() {
      let _this = this;
      viewTerminalVisitConfigActionApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogAddEditForm = {
          id: data.id,
          type: data.type,
          name: data.name,
          provinceId: data.provinceId || '',
          provinceName: data.provinceName,
          cityId: data.cityId || '',
          cityName: data.cityName,
          terminalType: data.terminalType || '',
          terminalTypeArray: [],
          actionRequire: data.actionRequire,
          imageNum: data.imageNum,
          questionNum: data.questionNum,
          description: data.description,
          isDefault: data.isDefault,
          remark: data.remark,
          questionOptionData: ''
        }
        if (data.terminalType.length > 0) {
          _this.dialogAddEditForm.terminalTypeArray = data.terminalType.split(',');
        }
        // 设置修改前的配置的问题清单
        _this.actionQuestionDataList = data.configActionQuestionDtoList || [];
        // 获取城市数据
        if (data.provinceId) {
          _this.loadCityData(data.provinceId);
        }
      })
    },
    // 获取省区选项数据
    loadProvinceData() {
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        this.provinceDataList = data || [];
      })
    },
    // 获取城市选项数据
    loadCityData(val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        this.cityDataList = data || [];
      })
    },
    // 省区选项变更处理
    handleProvinceChange(val) {
      let _this = this;
      if (val) {
        let selectItem = _this.provinceDataList.find(item => {
          return item.id === val
        })
        _this.dialogAddEditForm.provinceName = selectItem.name;
        _this.loadCityData(val);
      } else {
        _this.dialogAddEditForm.provinceName = '';
      }
    },
    // 城市选项变更处理
    handleCityChange(val) {
      let _this = this;
      if (val) {
        let selectItem = _this.cityDataList.find(item => {
          return item.id === val
        })
        _this.dialogAddEditForm.cityName = selectItem.name;
      } else {
        _this.dialogAddEditForm.cityName = '';
      }
    },
    // 动作规定要求选项变更处理
    handleRequireChange(val) {
      let _this = this;
      if (val === 1) {
        _this.sortTable = null;
      } else {
        _this.initDropSort();
      }
    },
    // 增加走访动作调研问题
    handleAddQuestion() {
      this.dialogChooseQuestionVisible = !this.dialogChooseQuestionVisible;
    },
    // 删除走访动作调研问题
    handleDeleteQuestion(index) {
      let _this = this;
      _this.actionQuestionDataList.splice(index, 1);
    },
    // 选择调研问题处理
    handleChooseActionQuestion(chooseData) {
      let _this = this;
      chooseData.forEach((item) => {
        let questionExist = false;
        _this.actionQuestionDataList.forEach((actionItem) => {
          if (actionItem.questionId === item.id) {
            questionExist = true;
            return;
          }
        })
        if (!questionExist) {
          _this.actionQuestionDataList.push({ questionId: item.id, questionType: item.type, questionTypeValue: item.typeValue, questionStem: item.question, orderNum: 0 });
        }
      })
    },
    // 保存
    handleSave() {
      let _this = this;
      _this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          if (_this.dialogAddEditForm.actionRequire === 2) {
            if (_this.actionQuestionDataList.length === 0) {
              _this.$message({ message: '工作任务未设置调研问题，不能保存', type: 'warning' })
              return false
            }
          }

          _this.$confirm('确认保存，是否继续？', "系统提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: 'warning', center: true }).then(async () => {
            let terminalType = '';
            _this.dialogAddEditForm.terminalTypeArray.forEach((item) => {
              terminalType += "," + item;
            })
            _this.dialogAddEditForm.terminalType = terminalType.substring(1);

            if (_this.dialogAddEditForm.actionRequire === 2) {
              _this.dialogAddEditForm.imageNum = 0;
              _this.dialogAddEditForm.questionNum = Number(_this.mathQuestionNum);
              _this.dialogAddEditForm.actionQuestionData = JSON.stringify(_this.actionQuestionDataList);
            } else {
              _this.dialogAddEditForm.questionNum = 0;
              _this.dialogAddEditForm.actionQuestionData = null;
            }

            saveTerminalVisitConfigActionApi(_this.dialogAddEditForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    // 关闭弹框
    modalClose() {
      let _this = this;
      // 直接修改父组件的属性
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
.textarea-item {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
  }
}
.tips-col {
  padding: 5px;
  min-height: 20px !important;
}
.button-col {
  text-align: center;
  min-height: 32px;
  margin-top: 28px;
}

.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}
</style>
